import { Component, OnInit, EventEmitter, Output, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { fromEvent, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, startWith, map, filter } from 'rxjs/operators';
import { ProjectDashboardService } from 'src/app/shared/services/project.dashboard.service';
import { NotifierService } from 'angular-notifier';
import { LoginService } from 'src/app/services/login.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-create-project',
  templateUrl: './create-project.component.html',
  styleUrls: ['./create-project.component.scss']
})
export class CreateProjectComponent implements OnInit , OnDestroy{
  @Output() updatePro =  new EventEmitter<boolean>();

  organizationList:any[] = [];
  filteredUser: Observable<any[]>;
  filteredTeam: Observable<any[]>;
  filteredOptions: Observable<string[]>;
  accessRole:any;
  defaultOrg:string='Crownit';
  indipendentSelectedUser:any[]=[];
  allUserSelected = false;
  allShareRepoUserSelected = false;
  public allUser:any[]=[]
  public allShareRepoUser:any[]=[]
  // public selectedTeam :any;
  public teamIds:any[] = [];
  public removedTeamID:string = '';
  public userList:any[] = [];
  public oldTlist:any[]=[];

  projectForm = new FormGroup({
    status: new FormControl(''),
    projectName: new FormControl(''),
    organizationName: new FormControl(''),
    usersName: new FormControl(''),
    teamName: new FormControl(''),
    team_uuid: new FormControl([]),
    user_uuid:new FormControl([]),
    share_repository:new FormControl([])
    // user_uuid:new FormControl([])
    });

  constructor(
    public projectService:ProjectDashboardService,
    private notifier: NotifierService,
    private router: Router,
    private logerror: LoginService,
    ) {
    this.accessRole = JSON.parse(localStorage.getItem('access'));
     }

  ngOnDestroy(){
    this.hideOldestNotification();
  }

  ngOnInit() {
    // this.accessRole = localStorage.getItem('access');
    this.getAllOrganization();
    this.filteredOptions = this.projectForm.controls.organizationName.valueChanges
      .pipe(
        startWith(''),
        map(value => this.filter(value))
      );

    if (!this.accessRole.super) {
      this.projectService.getTeamList({});
      this.projectService.getUsers({"status":1,"isOrgUser":true,'isPagination':false});
    }

    // this.filteredUser = this.projectForm.controls.usersName.valueChanges.pipe(
    //   startWith(''),
    //   debounceTime(400),
    //   distinctUntilChanged(),
    //   map(value => this.filterUser(value)),
    // )
  
    
  }

  private filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    // console.log("filter value is ===> ",filterValue)
    return this.organizationList.filter(option => option.organization_name.toLowerCase().includes(filterValue));
  }

  // private filterUser(value: string): string[] {
  //   console.log("value is ",value)
  //   const filterValue = value.toLowerCase();
  //   return this.projectService.userList.filter(option => option.name.toLowerCase().includes(filterValue));
  // }

  onUserChange(name){
    // console.log("name ",name)
    this.projectService.userList = this.projectService.filterByKey(this.projectService.orgUserList,'email',name,this.projectForm.value.user_uuid);
    this.checkAllUserSelection();
  }

  onTeamChange(name){
    this.projectService.teamList = this.projectService.filterByKey(this.projectService.orgTeamList,'name',name,this.projectForm.value.team_uuid)
  }

  onShareRepoUserChange(name){
    // console.log("name ",name)
    this.projectService.shareRepoUserList = this.projectService.filterByKey(this.projectService.orgUserList,'email',name,this.projectForm.value.share_repository);
    this.checkAllShareRepoSelection();
  }

  toggleAllUserSelection(): void {
    this.allUserSelected = !this.allUserSelected;
    if (this.allUserSelected) {
      const allUUIDs = this.projectService.userList.map(u => u.uuid);
      this.allUser = allUUIDs;
      this.allUser.push('selectAll');
      this.projectForm.get('user_uuid')?.patchValue(allUUIDs);
    } else {
      this.allUser = [];
      this.projectForm.get('user_uuid')?.patchValue([]);
      this.projectForm.get('team_uuid')?.patchValue([]);
    }
  }

  toggleAllShareRepoSelection(): void {
    this.allShareRepoUserSelected = !this.allShareRepoUserSelected;
    if (this.allShareRepoUserSelected) {
      const allUUIDs = this.projectService.shareRepoUserList.map(u => u.uuid);
      this.allShareRepoUser = allUUIDs;
      this.allShareRepoUser.push('selectAll');
      this.projectForm.get('share_repository')?.patchValue(allUUIDs);
    } else {
      this.allShareRepoUser = [];
      this.projectForm.get('share_repository')?.patchValue([]);
    }
  }

  changeOrg(){
    let query = {"org_uuid":this.organizationList.find(item =>{ return item.organization_name === this.defaultOrg}).uuid,"status":1,"isOrgUser":true, 'isPagination':false};
    // console.log("filter value is ===> ", JSON.stringify(query) )
    this.projectService.getTeamList(query);
    this.projectService.getUsers(query)
  }

  selectTeam(){

   let teamUsers = this.projectService.userList.filter(user => {
      return this.projectForm.value.team_uuid.find(team => {
         return team === user.team_uuid;
      });
   }).map(item=>{ return item.uuid});
  //  console.log("team user are",teamUsers)
   let removedTeam = "";
   this.oldTlist.forEach(t_uuid => {if(this.projectForm.value.team_uuid.indexOf(t_uuid) == -1){
      removedTeam = t_uuid}});

   let individualUser = this.projectForm.value.user_uuid;
   if (removedTeam && removedTeam != "") {
      let removedTeamUsere = this.projectService.userList.filter(user => user.team_uuid == removedTeam).map(item=> item.uuid);
      individualUser = individualUser.filter(item => { return !removedTeamUsere.includes(item)})
    }
   this.oldTlist = []
   this.oldTlist = this.projectForm.value.team_uuid;
   this.allUser = [...teamUsers,...individualUser];
   this.allUser = this.removeDuplicates(this.allUser);
   this.projectForm.patchValue({"user_uuid":this.allUser})

  }

  selectUsers(){

    this.checkAllUserSelection();
    // let individualUser = this.projectForm.value.user_uuid;
    // this.allUser = individualUser;
    // this.projectForm.patchValue({"user_uuid":this.allUser})
  }

  checkAllUserSelection(): void {
    let individualUser = this.projectForm.value.user_uuid;
    this.allUser = individualUser;
    if ((this.allUser.includes('selectAll') && this.allUser.length > this.projectService.userList.length) || (!this.allUser.includes('selectAll') && this.allUser.length >= this.projectService.userList.length)) {
      this.allUser.push('selectAll');
      this.allUserSelected = true;
    }else{
      this.allUserSelected = false;
      this.allUser = this.allUser.filter(item => item != 'selectAll');
    }
    this.projectForm.patchValue({"user_uuid":this.allUser});
  }

  selectUsersToShareRepo(){
    this.checkAllShareRepoSelection();
  }

  checkAllShareRepoSelection(): void {
    let individualUser = this.projectForm.value.share_repository;
    this.allShareRepoUser = individualUser;
    if ((this.allShareRepoUser.includes('selectAll') && this.allShareRepoUser.length > this.projectService.shareRepoUserList.length) || (!this.allShareRepoUser.includes('selectAll') && this.allShareRepoUser.length >= this.projectService.shareRepoUserList.length)) {
      this.allShareRepoUser.push('selectAll');
      this.allShareRepoUserSelected = true;
    }else{
      this.allShareRepoUserSelected = false;
      this.allShareRepoUser = this.allShareRepoUser.filter(item => item != 'selectAll');
    }
    this.projectForm.patchValue({"share_repository":this.allShareRepoUser});
  }

  removeDuplicates(arr: string[]): string[] {
    return Array.from(new Set(arr));
  }


  onCreate(){
    this.createProject();
  }
  onClose(){
    this.updatePro.emit(false);
  }

  getAllOrganization(){

    if (this.accessRole.super && this.accessRole['access_rules'] && this.accessRole['access_rules']['user_management'] && this.accessRole['access_rules']['user_management']['organizations'] && this.accessRole['access_rules']['user_management']['organizations']['view']) {
      this.projectService.getAllOrganization().subscribe(
        (data)=>{
          this.organizationList = typeof data['message'] == 'string' ? [] : data['message'];
          this.changeOrg();
        }
      );
    }else{
      this.organizationList = [];
    }
  }
  
  public showNotification( type: string, message: string ): void {
		this.notifier.notify( type, message );
	}

	public hideOldestNotification(): void {
		this.notifier.hideOldest();
	}

  createProject(){
    let org_id:string;
    if(this.accessRole.super === true){
      let id:any = this.organizationList.filter(option => option.organization_name.toLowerCase().includes(this.projectForm.value.organizationName.toLowerCase()))
      org_id = id[0].uuid;
    }else{
      org_id = this.accessRole.org_id;
    }
    let dataProject = {
      name: this.projectForm.value.projectName,
      // status: this.projectForm.value.status ? '1' : '0',
      status: '1',
      user_uuid:this.allUser.filter(item => item != 'selectAll'),
      share_repository:this.allShareRepoUser.filter(item => item != 'selectAll'),
      team_uuid:this.projectForm.value.team_uuid,
      organization_id: org_id
    };
    // console.log("dataProject is ",JSON.stringify(dataProject));
    this.projectService.createProject(dataProject).subscribe(
      (data)=>{
        // if(data){}
        if(data['status'] === 1){
          this.showNotification('success',data['message']);
          this.updatePro.emit(true);
          this.onClose();
        }else{
          this.showNotification('error',data['message']);
        }
      },
      (error)=>{
        if (error.status === 403) {
          this.router.navigate(['home/access-denied']);
        }
        else if (error.status === 401) {
          this.showNotification('error', 'User is not authorised');
          this.router.navigate(['home/access-denied']);
        }
        else {
          this.showNotification('error', 'Something went wrong');
        }
      }
    )
  }



}
